import { Link } from "react-router-dom";
import { categories } from "../content";
import { useEffect } from "react";

const Sitemap = () => {
  // Устанавливаем метатеги для SEO
  useEffect(() => {
    // Устанавливаем заголовок страницы
    document.title =
      "Карта сайта фотолокации Лесная Усадьба | Навигация по фотозонам в Подмосковье";

    // Устанавливаем мета-описание
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Карта сайта фотолокации Лесная Усадьба в Подмосковье. Навигация по всем страницам и разделам сайта, включая галерею фотозон."
      );
    }

    // Устанавливаем canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", "https://fotodacha.ru/#/sitemap");

    // Добавляем структурированные данные для страницы
    const sitemapStructuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Карта сайта фотолокации Лесная Усадьба",
      description:
        "Навигация по всем страницам и разделам сайта фотолокации в Подмосковье.",
      url: "https://fotodacha.ru/#/sitemap",
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Главная",
            item: "https://fotodacha.ru/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Карта сайта",
            item: "https://fotodacha.ru/#/sitemap",
          },
        ],
      },
      mainContentOfPage: {
        "@type": "WebPageElement",
        isPartOf: {
          "@type": "WebSite",
          name: "Лесная Усадьба",
          url: "https://fotodacha.ru/",
        },
      },
    };

    let scriptTag = document.querySelector("#sitemap-structured-data");
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.id = "sitemap-structured-data";
      scriptTag.type = "application/ld+json";
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(sitemapStructuredData);
  }, []);

  return (
    <div className="section bg-linen py-16">
      <div className="container">
        {/* Хлебные крошки для навигации и SEO */}
        <nav aria-label="Хлебные крошки" className="breadcrumbs py-2 mb-4">
          <ol className="flex flex-wrap items-center text-sm text-gray-600">
            <li className="breadcrumb-item">
              <Link to="/" className="hover:text-terracotta transition-colors">
                Главная
              </Link>
              <span className="mx-2">/</span>
            </li>
            <li className="breadcrumb-item" aria-current="page">
              <span className="text-terracotta font-medium">Карта сайта</span>
            </li>
          </ol>
        </nav>

        <h1 className="text-3xl font-bold text-center font-serif header-color md:text-4xl mb-8">
          Карта сайта фотолокации в Подмосковье
        </h1>

        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <div className="mb-8">
            <h2 className="text-2xl font-bold font-serif header-color mb-4">
              Основные страницы
            </h2>
            <ul className="space-y-2 ml-6 list-disc">
              <li>
                <Link to="/" className="text-terracotta hover:underline">
                  Главная страница
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-terracotta hover:underline">
                  О нашей усадьбе
                </Link>
              </li>
              <li>
                <Link
                  to="/#advantages"
                  className="text-terracotta hover:underline"
                >
                  Наши преимущества
                </Link>
              </li>
              <li>
                <Link
                  to="/#gallery-preview"
                  className="text-terracotta hover:underline"
                >
                  Наши фотозоны (превью)
                </Link>
              </li>
              <li>
                <Link
                  to="/#about-me"
                  className="text-terracotta hover:underline"
                >
                  О владельце
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-terracotta hover:underline">
                  Часто задаваемые вопросы
                </Link>
              </li>
              <li>
                <Link
                  to="/#contacts"
                  className="text-terracotta hover:underline"
                >
                  Контакты
                </Link>
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-bold font-serif header-color mb-4">
              Галерея фотозон
            </h2>
            <ul className="space-y-2 ml-6 list-disc">
              <li>
                <Link to="/gallery" className="text-terracotta hover:underline">
                  Галерея фотолокаций (все категории)
                </Link>
              </li>

              <li className="mt-4">
                <h3 className="text-xl font-medium header-color mb-2">
                  Категории фотозон:
                </h3>
                <ul className="space-y-2 ml-6 list-circle">
                  {categories.map((category) => (
                    <li key={category.id}>
                      <Link
                        to={`/gallery/${category.id}`}
                        className="text-terracotta hover:underline"
                      >
                        Фотозона "{category.title}" в Подмосковье
                      </Link>
                      <span className="text-gray-600 text-sm ml-2">
                        ({category.images.length} фото)
                      </span>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold font-serif header-color mb-4">
              Служебные страницы
            </h2>
            <ul className="space-y-2 ml-6 list-disc">
              <li>
                <Link to="/sitemap" className="text-terracotta hover:underline">
                  Карта сайта (HTML)
                </Link>
              </li>
              <li>
                <a
                  href="/sitemap.xml"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-terracotta hover:underline"
                >
                  Карта сайта (XML)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
